<div [class.hidden]="!show">
  <div class="loader-overlay">
    <div *ngIf="show" class="loader">      
      <button class="btn btn-info" type="button" >
        <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
        <span class="sr-only">Loading...</span>
      </button>
    </div>
  </div>
</div>
